import { Language } from 'apprise-core/language'
import { ResourceKey } from 'i18next'




export type IntlConfiguration = {

    translations: Partial<Record<Language, ResourceKey>>
    defaultLanguage: Language
    requiredLanguages: Language[]
}


export const defaultIntlConfiguration: IntlConfiguration = {


    translations: { 'en':{}},
    defaultLanguage: undefined!,
    requiredLanguages:undefined!

}




